<!-- 我的发布 -->
<template>
    <div>  
        <el-form :model="searchForm" ref="searchForm"  :inline="true"> 
            <el-form-item label="主题" prop="theme">
                <el-input style="width: 150px;"
                v-model="searchForm.theme" 
                maxlength="30"></el-input>
            </el-form-item>
            <el-form-item label="类型" prop="filterType" >
               <el-select v-model="searchForm.filterType" style="width: 150px;">
                <el-option label="双人赛" value="2"></el-option>
                <el-option label="单人赛" value="1"></el-option>
                <el-option label="队式赛" value="3"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="状态" prop="status">
                <el-select v-model="searchForm.status" style="width: 150px;">
                    <el-option 
                        v-for="item in statusOption"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="时间" prop="dateRange">
                <el-date-picker
                    style="width: 200px;"
                    v-model="searchForm.dateRange"
                    type="daterange"
                    value-format="yyyy-MM-dd"
                    range-separator="-"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期"
                    @change="selectDate"
                    />
            </el-form-item>  
            <el-form-item>
                <el-button type="primary" @click="searchQuery('searchForm')">查询</el-button>
                <el-button @click="resetForm('searchForm')">重置</el-button>
                <el-button type="primary" @click="toSalesLink" class="mg-b-10" v-if="adminRoles">营销系统</el-button>   
            </el-form-item>          
        </el-form>
        <el-table border :data="tableData" style="width: 100%;" v-loading="loading">
            <el-table-column  prop="title"  label="赛事主题" align="center">
                <template slot-scope="scope">
                    <router-link :to="{path: 'publishQuery', query: { id: scope.row.serial }}" 
                        class="pub-link">{{ scope.row.title }}</router-link>
                </template>
            </el-table-column>
            <el-table-column  prop="amount"   label="参赛人数" width="80" align="center"/>
            <el-table-column  prop="eventType"  label="赛事类型" width="80" align="center">
                 <template slot-scope="scope">
                    <el-tag effect="dark"
                        :type="scope.row.eventType === '单人赛' ? 
                        'success' : scope.row.eventType === '双人赛' ?'primary':'warning'" 
                        size="small"
                    >
                        {{ scope.row.eventType }}
                </el-tag>
                </template>
            </el-table-column>
            <el-table-column  prop="address"  label="赛事地点"  align="center"/>
            <el-table-column  prop="status"  label="状态" width="110" align="center">
                <template  slot-scope="scope">
                    <el-tag :type="limitStatus(scope.row.status)">{{ scope.row.status }}</el-tag>
                </template>
            </el-table-column>
            <el-table-column  prop="eventEndDate" label="赛事日期"  width="160" align="center"/>
            <el-table-column  fixed="right" label="操作" width="180">
                <template slot-scope="scope"> 
                    <div class="action-buttons">   
                    <el-tooltip content="编辑" placement="top" v-if="scope.row.status === '赛事报名中'">
                        <i class="el-icon-edit action-icon" @click="handleUpdate(scope.row)"></i>
                    </el-tooltip>         
                    <el-tooltip content="比赛设置" placement="top"  
                        v-if="scope.row.status === '赛事报名中' || scope.row.status === '赛事中'">
                        <i class="el-icon-setting action-icon" @click="handleSetting(scope.row)"></i>
                    </el-tooltip>
                    <el-tooltip content="复制" placement="top">
                        <i class="el-icon-document-copy custom-icon" @click="handleCopy(scope.row,'copy')"></i>
                    </el-tooltip>
                    <el-tooltip content="发放积分" placement="top" 
                        v-if="scope.row.scoreLimit">
                        <i class="el-icon-coin action-icon" @click="handleSetScore(scope.row)"></i>
                    </el-tooltip>
                    <el-tooltip content="清除成绩" placement="top" 
                        v-if="scope.row.scoreDelete">
                        <i class="el-icon-refresh-left custom-icon" @click="handleDeleteAllScore(scope.row)"></i>
                    </el-tooltip>
                    <el-tooltip content="导出选手" placement="top" 
                        v-if="scope.row.status == '赛事完成' || scope.row.status == '积分发放'">
                        <i class="el-icon-download action-icon" @click="handleExport(scope.row)"></i>
                    </el-tooltip>
                    <el-tooltip content="积分明细" placement="top" 
                        v-if="scope.row.status == '积分发放'">
                        <i class="el-icon-document action-icon" @click="handleDetailScore(scope.row)"></i>
                    </el-tooltip>
                    <el-tooltip content="退赛查询" placement="top">
                        <i class="el-icon-folder-delete action-icon" @click="handleQuitQuery(scope.row)"></i>
                    </el-tooltip>
                    <el-dropdown class="more-actions" trigger="click" @command="handleMoreAction">
                        <span class="el-dropdown-link">
                            <i class="el-icon-more action-icon"></i>
                        </span>
                        <el-dropdown-menu slot="dropdown">
                            <el-dropdown-item :command="{action: 'score', data: scope.row}" 
                                v-if="scope.row.status == '赛事完成' || scope.row.status == '积分发放'">
                                <i class="el-icon-document custom-icon"></i>查成绩
                            </el-dropdown-item>
                            <el-dropdown-item :command="{action: 'ad', data: scope.row}" 
                                v-if="scope.row.advSetting">
                                <i class="el-icon-data-board custom-icon"></i> 广告设置
                            </el-dropdown-item>
                            <el-dropdown-item :command="{action: 'payment', data: scope.row}" 
                                v-if="roles ==='管理员' || scope.row.userId == userId">
                                <i class="el-icon-money custom-icon"></i> 支付查询
                            </el-dropdown-item>
                            <el-dropdown-item divided :command="{action: 'delete', data: scope.row}" 
                                v-if="scope.row.limitDelete">
                                <i class="el-icon-delete custom-icon" style="color: #f56c6c;"></i> 
                                <span style="color: #f56c6c;">删除</span>
                            </el-dropdown-item>
                        </el-dropdown-menu>
                    </el-dropdown>              
                    </div>  
                </template>  
                <!-- <template slot-scope="scope">               
                    <el-button @click="handleUpdate(scope.row)" type="text" size="small" 
                    v-if="scope.row.status === '赛事报名中'">编辑</el-button>
                    <el-button @click="handleSetting(scope.row)" type="text" size="small" 
                        v-if="scope.row.status === '赛事报名中' || scope.row.status === '赛事中'">比赛设置</el-button>
                    <el-button @click="handleLook(scope.row)" type="text" size="small" 
                        v-if="scope.row.status == '赛事完成' || scope.row.status == '积分发放'">查成绩</el-button>
                    <el-button @click="handleCopy(scope.row,'copy')" type="text" size="small"
                        >复制</el-button>
                    <el-button @click="handleSetScore(scope.row)" type="text" size="small"
                        v-if="scope.row.scoreLimit">发放积分</el-button>
                    <el-button @click="handleDetailScore(scope.row)" type="text" size="small"
                        v-if="scope.row.status == '积分发放'">积分明细</el-button>
                    <el-button @click="handleDelete(scope.row)" type="text" size="small"
                        v-if="scope.row.limitDelete"
                        >删除</el-button>
                    <el-button @click="handleDeleteAllScore(scope.row)" type="text" size="small" color="#f0f"
                        v-if="scope.row.scoreDelete"
                        >清除成绩</el-button>
                    <el-button @click="handleSettingAdvert(scope.row)" type="text" size="small" color="#f0f"
                        v-if="scope.row.advSetting"
                        >广告设置</el-button>
                    <el-button  v-if=" roles ==='管理员' || scope.row.userId == userId"
                            @click="handleQuery(scope.row)" type="text" size="small">支付查询</el-button>
                    <el-button  v-if="scope.row.status == '赛事完成' || scope.row.status == '积分发放'"
                            @click="handleExport(scope.row)" type="text" size="small">导出选手</el-button>
                </template>                   -->
            </el-table-column>
        </el-table>
        <pagination
            style="text-align:right"
            v-show="total > 10"
            :total="total"
            :page.sync="queryParams.page"
            :limit.sync="queryParams.pagesize"
            @pagination="initData"
        />
<!-- 新增积分发放 确认对话框 -->
<el-dialog title="积分明细" :visible.sync="open" width="1000px" class="grade-dialog"
    style="height:500;overflow-y: scroll;" append-to-body>
    <el-row class="center size20 mg-b-10 bold">{{ pubTitle }}</el-row>
    <div class="flex-row-1">
        <el-table :data="firstTableData" 
        v-if="firstTableData.length > 0"
        :row-class-name="tableRowClassName"
        :cell-class-name="tableCellStyle"
        class="custom-table custom-table2"
        style="width: 100%" border>
        <el-table-column   
            v-for="(item, index) in dynamicHeaders"
            :key="index"
            :prop="item.prop"
            :label="item.label" 
            align="center">
        </el-table-column>
    </el-table>
    <el-table :data="secondTableData" 
        v-if="secondTableData.length > 0"
        :row-class-name="tableRowClassName"
        :cell-class-name="tableCellStyle"
        class="custom-table custom-table2"
        style="width: 100%;margin-left: 15px;" border>
        <el-table-column   
            v-for="(item, index) in dynamicHeaders"
            :key="index"
            :prop="item.prop"
            :label="item.label" 
            align="center">
        </el-table-column>
    </el-table>
    </div>    
    <div slot="footer" class="dialog-footer" v-if="disabled">
        <el-button type="primary" @click="submitForm">确 定</el-button>
        <el-button @click="cancel">取 消</el-button>
    </div>
</el-dialog>
</div>
</template>

<script>
import pagination  from '@/components/Pagination'
import PageBack from '@/components/PageHeader'
import GradeDetail from './gradeDetail'
export default {
    components:{
        pagination,
        PageBack,
        GradeDetail
    },
    data() {
        return {
            open: false,
            loading: false,
            searchForm:{
                dateRange: '',
                status: '',
                theme: '',
                filterType: '',
            },
            publishId: '',
            startDate: 0,
            endDate: 0,
            queryParams: {
                page: 1,
                pagesize: 10
            },
            tableData: [],  
            amount: 0,  
            total: 0,
            statusOption:[
                {label:'全部', value:''},
                {label:'赛事中', value:3},
                {label:'赛事报名中', value:1},
                {label:'赛事完成', value:0},               
                {label:'赛事取消', value:77},
            ],
            tableDataGrade: [],
            firstTableData: [],
            secondTableData: [],
            tableHeaders: [
                {label: '排名', prop: 'rank'},                
                {label: '名称', prop: 'username'},
                {label: '搭档', prop: 'partername'},
                {label: '积分', prop: 'score'},    
                {label: '角色', prop: 'rolename'},              
               
            ],
            dynamicHeaders:[],
            disabled: false,
            pubTitle: '',
            pubType: null,
            exportData: []
        }   
    },
    created() {
       
    },
    mounted() {
        this.initData()
    },
    computed:{
        title(){
            return this.$route.meta.title
        },
        userId(){
            return localStorage.getItem('playerNo')
        },
        roles(){
            return localStorage.getItem('roles')
        },
        adminRoles(){
            let value = localStorage.getItem('roles')
            if(value === '管理员'){
                return true
            }else{
                return false
            }            
        }        
    },
    methods: {
        initData(){
            let params = {
                opcode: this.$code.PublishAllCode,
                i_serial_mark: '',
                c_status: this.searchForm.status,
                v_type: this.searchForm.filterType,
                v_theme: this.searchForm.theme,
                start_date: this.startDate,
                end_date: this.endDate,
                pagesize: this.queryParams.pagesize,
                page: this.queryParams.page,
            }
            this.loading = true
            this.$api.requestAPI(params).then(res =>{
                if (res.IsSuccess) {
                    let result = res.Data.DataTable
                    this.total = res.Data.SumCount

                    this.tableData = result.map(item=>{
                    let startDate = this.$help.formatDate(item['报名开始日期'])
                    let endDate = this.$help.formatDate(item['报名截止日期'])
                    // let startTime = this.$help.formatTime(item['报名开始时间'])
                    // let endTime = this.$help.formatTime(item['报名截止时间'])
                    let eventTypeArr =  this.$global.eventTypeList.filter(i=>i.label ===item['类型'])
                    // console.log(eventTypeArr[0].name)
                    return{
                        index: item['序号'],
                        serial: item['标识'],
                        userId:item['发布人'],
                        title: item['主题'],
                        status: item['状态'],
                        limit: this.getRoleAuditLimit(item['状态'],item['发布人']),
                        limitDelete: this.getRoleDeleteLimit(item['状态'],item['发布人']),
                        scoreLimit: this.getScoreLimit(item['状态'],item['发布人']),
                        scoreDelete: this.getScoreDelete(item['状态']),
                        advSetting: this.getAdvSettingLimit(item['状态']),
                        type:  eventTypeArr[0].value,
                        eventType: eventTypeArr[0].name,
                        amount: item['参赛人数'],
                        address: item['赛事地点省份'] +''+ item['赛事地点市'] +''+item['赛事地点'],
                        sponsor: item['赞助'],
                        award: item['奖励设置'],
                        eventFlow: item['赛事流程'],
                        notice: item['报名须知'],
                        rules:item['竞赛规则'],
                        letter: item['参赛承诺'],
                        applyStartDate: startDate,
                        applyEndDate: endDate,
                        applyStartEnd: startDate +'~'+ endDate,
                        eventStartDate: item['赛事开始日期'],
                        eventEndDate: item['赛事结束日期']
                    }
                }) 
                this.loading = false
            }
        })            
    },
    handleLook(row){
        if(row.type === 3){
            this.$router.push({
                path: '/teamGroupRankQuery',
                query:{
                    id: row.serial
                }                
            })
        }else{
            this.$router.push({
                path: 'playerScore',
                query: {
                    id: row.serial
                }
            })
        }
    },
    handleUpdate(row){
        this.$router.push({
            path: 'updatePublish',
            query: {
                id: row.serial
            }
        })
    }, 
    //复制一个比赛
    handleCopy(row,type){
        this.$router.push({
            path: 'publish',
            query: {
                id: row.serial,
                type: type
            }
        })
    },  
    selectDate(d){
        if(d){
            this.startDate = d[0].replace(/\-/g,'')
            this.endDate = d[1].replace(/\-/g,'')
        }else{
            this.startDate = 0
            this.endDate = 0
        }
       
    },
    searchQuery() {
        this.initData()
    },
    resetForm(formName) {
        this.$refs[formName].resetFields();
        this.startDate = 0
        this.endDate = 0
    },
    handleSetting(row){
        console.log(typeof row.type)
        localStorage.setItem('tabs','a')        
        if(row.type=== 3){
            this.$router.push({
                path: '/teamSetting',
                query: {
                    id: row.serial,
                    type: row.type
                },
            })
        }else{
            this.$router.push({
                path: '/pubSetting',
                query: {
                    id: row.serial,
                    type: row.type
                },

            })
        }
    },
    getRoleAuditLimit(status,userId){
        if(status === '赛事报名中'){
            if(this.roles === '管理员'){
                return true
            }else if(this.roles === '裁判'){
                if(this.userId.toString() === userId.toString()){
                    return true
                }else{
                    return false
                }
            }
        }else{
            return false
        }
    },
    getRoleDeleteLimit(status,userId){         
        if(this.roles === '管理员'){
            return true
        }else if(this.roles === '裁判' || this.roles === '掼蛋协会' || this.roles === '掼蛋俱乐部'){
            if(this.userId.toString() === userId.toString()){
                return true
            }else{
                return false
            }
        }else{
            return false
        }          
    },
    getScoreLimit(status,userId){         
        if(status === '赛事完成'){
            if(this.roles === '管理员'){
                return true
            }else if(this.roles === '裁判' || this.roles === '掼蛋协会' || this.roles === '掼蛋俱乐部'){
                if(this.userId.toString() === userId.toString()){
                    return true
                }else{
                    return false
                }
            }
        }else{
            return false
        }          
    },
    getAdvSettingLimit(status){
        if(status === '赛事报名中'|| status === '赛事中'){
            if(this.roles === '管理员'){
                return true
            }else{
                return false
            }           
        }else{
            return false
        }        
    },
    getScoreDelete(status){
        if(status === '赛事完成' || status === '赛事中' || status === '赛事取消'){
            return true
        }else{
            return false
        }    
    },
    limitStatus(value){
        if(value==='赛事完成'){
            return 'success'
        }else if(value==='赛事取消'){
            return 'info'
        }else if(value==='赛事报名中' || value==='赛事中'){
            return 'danger'
        }else if(value==='积分发放'){
            return ''
        }
    },
    handleSetScore(row){
        this.publishId  = row.serial   
        this.disabled  = true  
        this.pubTitle = row.title   
        this.pubType = row.type
        setTimeout(()=>{            
            this.getQuery(row.serial)
        },500)        
    },
    getQuery(pubId){
        let params = {
            opcode: this.$code.SetGradeQuery,
            i_serial_mark: pubId
        }
        this.$api._requestAPI(params).then(res=>{
            if(res.IsSuccess){
                this.open = true
                let result = res.Data.DataTable 
                if(result.length > 0){                
                    this.tableDataGrade = result.map(item=>{                    
                        return{                            
                            rank: item['赛事角色'] === '赛事选手' ? item['名次']: '',
                            username: item['姓名'],
                            partername: item['搭档姓名'],
                            score: item['积分'],
                            phone: item['手机号'],    
                            rolename: item['赛事角色'], 
                        }
                    })                       
                    this.isShow = true
                    // 获取所有唯一的字段名
                    const fields = Array.from(new Set(this.tableDataGrade.flatMap(Object.keys)));
                     // 过滤出至少有一个非空值的字段
                     let filterArrNew= fields.filter(field => this.tableDataGrade.some(row => row[field] !== null && row[field] !== undefined && row[field] !== ''));
                    this.dynamicHeaders = this.tableHeaders.filter(i=>filterArrNew.includes(i.prop))

                    let  playerArr  = JSON.parse(JSON.stringify(this.tableDataGrade))
                        if(playerArr.length > 10){
                            const splitSize = Math.round(playerArr.length / 2); 
                            this.firstTableData = playerArr.slice(0, splitSize);  
                            this.secondTableData = playerArr.slice(splitSize);  
                        }else{
                            this.firstTableData = playerArr
                            this.secondTableData = []
                        }
                }else{
                    this.$message.error('暂无成绩')
                }                               
            }else{
                this.$message.error(res.Message)
            }
        })
    },
    tableRowClassName({row, rowIndex}){
        // 选手以外的角色一种颜色
        if(row.rolename !== '赛事选手'){
            return 'green-row'
        }
         // 一桌一种颜色
        if(row.rank === 1){
            return 'gold-row'
        }else if(row.rank === 2){
            return  'silver-row'
        }else if(row.rank === 3){
            return  'brown-row'
        }
    },
    tableCellStyle({row,column, rowIndex}){
        if(column.property === 'score'){
                return 'red-row'
        }
    },
    submitForm(){
        let params = {
            opcode: this.$code.FinishConfirmScore,
            i_serial_mark: this.publishId
        }
        this.$api.requestAPI(params).then(res =>{
            if(res.IsSuccess){
                this.$message.success("积分发放成功！")
                this.initData()
            }else{
                this.$message.error(res.Message)
            }
        })
    },
    handleMoreAction(command){
        const { action, data } = command;
          
          switch(action) {
            case 'score':
                this.handleLook(data)
                break;
            case 'ad':
                this.handleSettingAdvert(data)
              break;
            case 'payment':
                this.handleQuery(data)
              break;
            case 'delete':
                this.handleDelete(data)

              break;
          }
    },
    cancel(){
        this.open= false
        this.tableDataGrade = []
    },
    handleDetailScore(row){
        this.disabled = false
        this.pubTitle = row.title     
        this.pubType = row.type
        console.log(this.pubTitle)
        setTimeout(()=>{
            this.open = true
            this.getQuery(row.serial)
        },500)   
    },
    handleDelete(row){
        this.$confirm('删除后将不能查看选手比赛成绩和相关信息','确定删除赛事吗？').then(res=>{
            let params = {
                opcode: this.$code.PublishDelete,
                i_serial_mark: row.serial
            }
            this.$api.requestAPI(params).then(data=>{
                if(data.IsSuccess){
                    this.$message.success('删除成功')
                    this.initData()
                }else{
                    this.$message.error(data.Message)
                }
            })
        }).catch(err=>{
            console.log(err)
        })
    },
    handleDeleteAllScore(row){
        this.$confirm('清除后将不能查看选手比赛成绩和相关信息','确定清除赛事成绩吗？').then(res=>{
            let params = {
                opcode: this.$code.DeleteAllScore,
                i_serial_mark: row.serial
            }
            this.$api.requestAPI(params).then(data=>{
                if(data.IsSuccess){
                    this.$message.success('删除成功')
                    this.initData()
                }else{
                    this.$message.error(data.Message)
                }
            }).catch(err=>{
            console.log(err)
            })
        })
    },  
    handleSettingAdvert(row){
        this.$router.push({
            path: '/pubAdvert',
            query: {
                id: row.serial
            }
        })
    },
    handleQuery(row){            
        let params = {
            opcode: this.$code.AdminIntroPayment,
            i_serial_mark: row.serial,
            c_status: 0,
            start_date: 0,
            end_date: 0,                
        }
        this.$api.requestAPI(params).then(res =>{
            if(res.IsSuccess){
                // console.log(res)
                let count = res.Data.SumCount
                this.$router.push({
                    path: '/paymentQuery',
                    query:{
                        id: row.serial
                    }                
                })
                // if(count > 1){
                //     this.$router.push({
                //         path: '/paymentQuery',
                //         query:{
                //             id: row.serial
                //         }                
                //     })
                // }else{
                //     this.$message.error('暂无数据！')
                // }
            }
        })
    },
    handleExport(row){
        let params = {
            opcode: this.$code.PubEncounter,
            i_serial_mark: row.serial,
            name:'',
            i_players_number: '',
        }
        this.$api.requestAPI(params).then(res =>{
            if (res.IsSuccess) {
                let result = res.Data.DataTable
                if(result.length > 0){                   
                    if(row.type === 1){
                        this.exportData = result.map(item=>{
                            return{                            
                                '选手编号': item['选手编号'],
                                '选手名称': item['选手名称'],
                                '选手手机号': item['选手手机号'],   
                                '协会（俱乐部）': item['协会（俱乐部）'],
                                '签到状态': item['状态'] ==='参赛'?'已签到':'未签到'
                            }
                        })                       
                    }else{
                        this.exportData = result.map(item=>{
                            return{                            
                                '选手编号': item['选手编号'],
                                '选手名称': item['选手名称'],
                                '搭档名称': item['搭档名称'],
                                '选手手机号': item['选手手机号'],   
                                '搭档手机号': item['搭档手机号'],
                                '协会（俱乐部）': item['协会（俱乐部）'],
                                '签到状态': item['状态'] ==='参赛'?'已签到':'未签到'
                            }
                        })
                    }  
                    setTimeout(()=>{
                        this.$help.ExportFormData(this.exportData, row.title)
                    },500)
                }    
            }    
        })             
    },
    toSalesLink(){
        // 正式环境
        window.open('http://122.51.64.3:9892/fy_manager/', '_blank'); 
        // window.open('http://yxxt.54970408.cn:9892/Fy_Manager/Default.aspx', '_blank');  
        // 测试环境
        // window.open('http://222.84.172.181:9892/commission/Fy_Manager/', '_blank');
    },
    // 退赛查询
    handleQuitQuery(row){
        console.log(row)
        this.$router.push({
            path: '/quitQuery',
            query: {
                id: row.serial
            }
        })
    }
}
}
</script>
<style lang='scss' scoped>
@import '@/assets/css/style.scss';
.pub-link{
    text-decoration: underline;
    color: red
}
.custom-table >>> .el-table__header-wrapper tr th{
    font-size: 20px;
    color: #000;
}
.custom-table >>> .el-table{
    font-size: 20px;
}
.custom-table >>> .cell{
    font-size: 16px;
}
.el-table >>> .green-row{
    background-color: #bbffbb
}
.el-table >>> .red-row{
    // color: red;
    // font-size: 16px;
}
.el-dialog{
    // height: 600px;
    // overflow-y: auto;
}
.grade-dialog >>>.el-dialog__body{
    padding-top:0
}
.custom-table >>> .gold-row{
    background-color: #FFD700;
}
.custom-table >>> .silver-row{
    background-color: #C0C0C0;
}
.custom-table >>> .brown-row{
    background-color: #CD7F32;
}

 .action-buttons {
    display: flex;
    gap: 8px;
}
.action-icon {
    font-size: 20px;
    cursor: pointer;
    color: #606266;
    transition: color 0.3s;
}
.action-icon:hover {
    color: #409eff;
}
.action-icon.delete:hover {
    color: #f56c6c;
}
.more-actions {
    margin-left: 5px;
}
.custom-icon{
    font-size: 20px;
}
</style>


// WEBPACK FOOTER //
// src/views/publish/components/publishTab.vue